import { createPromiseClient } from '@bufbuild/connect';
import { ConnectTransportOptions } from '@bufbuild/connect-web';
import {
  ResponseStatusCodeFunction,
  lmsTransport,
  lmsTransportWithLogoutHandler,
} from './transports';
import { LmsAssessmentStudentAPIServiceV2 } from '@protos/learning_management/lms.assessment.student.apis_connect';

export const LmsAssessmentStudentAPIServiceV2Client = createPromiseClient(
  LmsAssessmentStudentAPIServiceV2,
  lmsTransport
);

export const useLmsAssessmentStudentAPIServiceV2ClientWithStatusCodeHandler = (
  options: Partial<ConnectTransportOptions>,
  responseStatusCodeFunction: ResponseStatusCodeFunction
) =>
  createPromiseClient(
    LmsAssessmentStudentAPIServiceV2,
    lmsTransportWithLogoutHandler(options, responseStatusCodeFunction)
  );
